module.exports = __webpack_public_path__ + "static/media/lenscare.6025ad12.png";